module.exports = __webpack_public_path__ + "img/fluid-wagon-shadow-4.b5fc3207.png";